import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@mantine/core';

import { menuListTeknisiKoordinator, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import AccountResetEmail from "../../pagesSub/accountUser/AccountResetEmail";
import AccountResetUsernamePassword from "../../pagesSub/accountUser/AccountResetUsernamePassword";

const AccountTK = () => {

    const { subMenu, tab } = useParams();
    const menu = menuListTeknisiKoordinator.account.slug;
    const roleUser = role.teknisi;
    const slugLink = roleUser.subLevel.teknisi_kepala.slugLink;

    return (
        <LayoutAppShell
            stateMenuList={menuListTeknisiKoordinator}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListTeknisiKoordinator.account.subMenu.one.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListTeknisiKoordinator}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListTeknisiKoordinator.account.subMenu.one.tabs.one.flag}>
                                {menuListTeknisiKoordinator.account.subMenu.one.tabs.one.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListTeknisiKoordinator.account.subMenu.one.tabs.two.flag}>
                                {menuListTeknisiKoordinator.account.subMenu.one.tabs.two.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListTeknisiKoordinator.account.subMenu.one.tabs.one.flag}>
                            <AccountResetEmail />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListTeknisiKoordinator.account.subMenu.one.tabs.two.flag}>
                            <AccountResetUsernamePassword />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default AccountTK;